import {takeEvery} from 'redux-saga';
import {call, put} from 'redux-saga/effects';
import {appError, busy, ready} from './Status';

export const GET_QUESTIONS = 'app-qa/questions/GET_QUESTIONS';
export const getQuestions = (order = 'latest', tag, context = 'general', offset, limit, append = false) =>
  ({type: GET_QUESTIONS, order, tag, offset, context, limit, append});

export const QUESTIONS_REQUEST_SUCCESS = 'app-qa/questions/QUESTIONS_REQUEST_SUCCESS';
export const questionsRequestSuccess = (response, append) => ({type: QUESTIONS_REQUEST_SUCCESS, response, append});

export const SET_LOADING_QUESTIONS = 'app-qa/questions/SET_LOADING_QUESTIONS';
export const setLoadingQuestions = (loading, order, tag) => ({type: SET_LOADING_QUESTIONS, order, tag, loading});

export const SET_ORDER = 'app-qa/questions/SET_ORDER';
export const setOrder = (order, tag, context) => ({type: SET_ORDER, order, tag, context});

export const SET_ORDER_SUCCESS = 'app-qa/questions/SET_ORDER_SUCCESS';
export const setOrderSuccess = (order) => ({type: SET_ORDER_SUCCESS, order});

export const actions = {
  GET_QUESTIONS,
  QUESTIONS_REQUEST_SUCCESS,
  SET_LOADING_QUESTIONS,
  SET_ORDER,
  SET_ORDER_SUCCESS,
};

const initialState = {
  order: 'latest',
  offset: 0,
  limit: 20,
  total: 0,
  loadingQuestions: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOADING_QUESTIONS: {
      return Object.assign({}, state, {order: action.order, tag: action.tag, loadingQuestions: action.loading});
    }
    case QUESTIONS_REQUEST_SUCCESS: {
      const updatedQuestions = action.append ?
        [].concat(state.questions, action.response.result) :
        action.response.result;
      return {...state,
        offset: action.response.offset,
        limit: action.response.limit,
        total: action.response.total,
        questions: updatedQuestions,
        loadingQuestions: false,
      };
    }
    case SET_ORDER_SUCCESS: {
      return {...state, order: action.order};
    }
    default:
      return state;
  }
}

export function sagas({qaClient}) {
  function *getQuestionsSaga({order, tag, context, offset, limit, append}) {
    if (!append) { yield put(setLoadingQuestions(true, order, tag)); }
    try {
      yield put(busy({blockUi: true}));
      const response = yield call(() => qaClient.getQuestions(order, tag, context, offset, limit));
      yield put(questionsRequestSuccess(response, append));
      yield put(ready());
    } catch (err) {
      yield put(appError({err}));
    }
  }

  function *setOrderSaga({order, tag, context}) {
    yield put(setLoadingQuestions(true, order, tag));
    yield put(getQuestions(order, tag, context));
    yield put(setOrderSuccess(order));
  }

  return {
    *watchGetQuestions() { yield* takeEvery(GET_QUESTIONS, getQuestionsSaga); },
    *watchSetOrder() { yield* takeEvery(SET_ORDER, setOrderSaga); },
  };
}
